<template lang="pug">
link-base.link-side-menu(@click='clickEvent')
  image-base.link-side-menu__icon(:src='require(`@/assets/img/${img}`)')
  .link-side-menu__text.text-xlarge.font-bold
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

@Component({
  components: {
    LinkBase,
    ImageBase,
  },
})
/**
 * サイドメニューのアイコン付きリンク
 */
export default class LinkSideMenu extends Vue {
  @Prop()
  img!: string

  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.link-side-menu
  display flex
  text-decoration none
  &__icon
    width 60px
    height 60px
  &__text
    padding 10px
</style>
